import { E164Number } from 'libphonenumber-js/core'

import { CustomerAddress } from 'Types'

export const customerAddressTitle = (customerAddress: CustomerAddress): string =>
  `${customerAddress.address1}, ${customerAddress.city} ${customerAddress.zipCode}, ${customerAddress.country}`

// API returns phone without a leading `+` (Phony.normalize strips it), while
// PhoneInput/react-phone-number-input always produces E.164 with `+` — normalize
// both sides before comparing a locally-entered phone against a value from the API.
export const normalizePhone = (value: E164Number | undefined | null): string => (value ? value.replace(/\D/g, '') : '')
